export default __webpack_public_path__ + "static/media/monchisLogo.636303b9.png";